import { apiConf, sendRequest, ppAxios } from '../config'

/**
 * 安全中心-修改密码-发送验证码
 */
export const updateLoginPwdSendMsg = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateLoginPwdSendMsg'], params)
}

/**
 * 安全中心-修改密码
 */
export const updateLoginPwd = (params) => {
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	params.machineId = machineId
	return sendRequest(['POST', '/merchant/acquirer/security/updateLoginPwd'], params)
}

/**
 * 安全中心-修改手机-发送新手机验证码
 */
export const updateBindNewPhoneSendMsg = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindNewPhoneSendMsg'], params)
}

/**
 * 安全中心-修改手机-发送手机验证码
 */
export const updateBindPhoneSendMsg = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindPhoneSendMsg'], params)
}

/**
 * 安全中心-修改手机-发送邮箱验证码
 */
export const updateBindPhoneSendEmail = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindPhoneSendEmail'], params)
}

/**
 * 安全中心-修改手机
 */
export const updateBindPhone = (params) => {
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindPhone'], { machineId, ...params })
}

/**
 * 安全中心-修改邮箱-发送手机验证码
 */
export const updateBindEmailSendMsg = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindEmailSendMsg'], params)
}

/**
 * 安全中心-修改邮箱-发送邮箱验证码
 */
export const updateBindNewEmailSendEmail = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindNewEmailSendEmail'], params)
}

/**
 * 安全中心-修改邮箱
 */
export const updateBindEmail = (params) => {
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	return sendRequest(['POST', '/merchant/acquirer/security/updateBindEmail'], { machineId, ...params })
}

/**
 * 密钥管理-查询
 */
export const selectKeys = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/store/selectKeys'], params, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
/**
 * 密钥管理-密钥详情
 */
export const getKey = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/selectKeyDetail'], params)
}

/**
 * 密钥管理-获取密钥类型枚举
 */
export const getKeyTypeEnum = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/store/getKeyTypeEnum'], params)
}

/**
 * 密钥管理-发送手机验证码
 */
export const refreshKeySendMsg = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/refreshKeySendMsg'], params, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}

/**
 *密钥管理-刷新
 */
export const generateKey = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/generateKey'], params)
}

/**
 * 导出密钥
 */
export const downloadKeys = (params, option) => {
	return ppAxios(['POST', '/merchant/acquirer/store/downloadKeys'], params, option)
}
/**
 * 获取服务器公钥
 */
export const getPublicKey = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/encrypt/publicKey'], params)
}

// 预申请VA
export const preApplyCreateVA = () => {
	return sendRequest(['POST', '/merchant/acquirer/beneficiaryVa/preApplyCreateVa'])
}

// 获取中台Token
export const getMetaToken = (params = {}) => {
	const machineId = sessionStorage.getItem('machineId') // 机器码ID
	params.machineId = machineId
	return sendRequest(['POST', '/merchant/acquirer/user/getMetaToken'], params)
}
